import type {EditSupplierContactFormPayload} from "./edit-supplier-contact.schema";

import {editSupplierContact} from "@project/sdk/engineering";
import {EditSupplierContactBody} from "@project/sdk/engineering/zod";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../../../supplier-keys";

import {editSupplierContactMapper} from "./edit-supplier-contact.mapper";

export function editSupplierContactMutationOptions(supplierId: string, contactId: number) {
  return mutationOptions({
    mutationKey: supplierMutationKeys.editSupplierContact,
    mutationFn: (payload: EditSupplierContactFormPayload) => {
      const request = EditSupplierContactBody.parse(editSupplierContactMapper.toSdk(payload));
      return editSupplierContact(supplierId, contactId, request);
    },
    onSuccess: async (_data, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierKeys.detail(supplierId)}),
        client.invalidateQueries({queryKey: supplierKeys.lists()}),
      ]);
    },
  });
}
